<template>
    <div>
        <v-app-bar absolute app flat outlined color="background">
            <div class="d-flex align-center" cols="12">
                <v-app-bar-nav-icon v-if="!drawer" @click.stop="$emit('update-drawer')"></v-app-bar-nav-icon>
                <v-toolbar-title>Energy dashboard</v-toolbar-title>
            </div>
            
            <v-spacer></v-spacer>

            <v-menu min-width="250">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn text v-bind="attrs" v-on="on" fab small>
                        <v-icon>mdi-account-circle</v-icon>
                    </v-btn>
                    <v-btn text @click="redirect" fab small>
                        <v-icon>mdi-home</v-icon>
                    </v-btn>
                </template>

                <v-card>
                    <v-list>
                        <v-list-item>
                            <v-list-item-content>
                                <div class="overline mb-4">User Profile</div>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="openDialog">
                            <v-list-item-content>
                                <v-list-item-title>Account</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon>
                                <v-icon>mdi-account</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                        <v-list-item @click="() => {}">
                            <!-- :to="{ name: 'Settings' }" -->
                            <v-list-item-content>
                                <v-list-item-title>Settings</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon>
                                <v-icon>mdi-cog</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                        
                        <v-divider></v-divider>
                        <v-list-item @click="doLogout">
                            <v-list-item-content>
                                <v-list-item-title>Log Out</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon>
                                <v-icon>mdi-exit-to-app</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-menu>
        </v-app-bar>
        <formAccountInfo
        :openPopUp="openPopUp"
        :currUser="user"
        @close="closeDialog"/>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import formAccountInfo from '../formAccountInfo'
export default {
    name: 'navbar',
    props: ['drawer'],
    computed: {
        ...mapState('user', {
            logged: state => state.logged,
            user: state => state.profile
        })
    },
    components: { formAccountInfo },
    data() {
        return {
            openPopUp: false
        }
    },
    methods:{
        ...mapActions( { logout: 'user/logout', resetMeters: 'meters/resetMeters' } ),
        async doLogout(){
            await this.resetMeters()
            try {
                await this.logout()
                this.$router.push({ name: 'Login' })
            } catch (error) {
                console.log(error)
            }
        },
        openDialog(){
            this.openPopUp = true
        },
        closeDialog(){
            this.openPopUp = false
        },
        async redirect(){
            this.$router.push({name:'Main'}).catch(()=>{})             
        },
    }
}
</script>
